/**
 * The site's languages. No imports on purpose: the Cloudflare Pages Function [F35] and the
 * `node --test` regression tests read this list too. The app reads it through `locales.js`.
 */
export const SUPPORTED_LOCALES = [{
  code: 'lv',
  base: '',
  locale: 'lv_LV',
  name: 'LV',
  displayName: 'Latviešu',
  flag: '🇱🇻'
}, {
  code: 'en',
  base: '/en',
  locale: 'en_US',
  name: 'EN',
  displayName: 'English',
  flag: '🇬🇧'
}, {
  code: 'ru',
  base: '/ru',
  locale: 'ru_RU',
  name: 'RU',
  displayName: 'Русский',
  flag: '🇷🇺'
}]

/** The language of a URL without a locale prefix (its `base` is ''). */
export const DEFAULT_LOCALE_CODE = 'lv'

export const LOCALES_REGEX = '(lv|en|ru)'
